import { call, put, takeEvery } from 'redux-saga/effects';
import apiService from '../../api/service/apiService';
import {
  getLoginRequest,
  getLoginSuccess,
  getLoginFailure,
  getLogoutRequest,
  getLogoutSuccess,
  getLogoutFailure,
  getLoginRequestReset,
  type LoginRequest,
  type LoginResponse,
} from '../slices/authSlice';
import { ENDPOINTS } from '../../api/endPoints';

// API call to login
function* loginApi(payload: LoginRequest): Generator<any, any, any> {
  try {
    const response: { data: LoginResponse } = yield call(apiService.post, {
      endpoint: ENDPOINTS.login,
      body: {
        email: payload.email,
        password: payload.password,
      },
    });
    
    return response.data;
  } catch (error) {
    throw error;
  }
}

function* getLoginSaga(action: { type: string; payload: LoginRequest }): Generator<any, void, any> {
  try {
    const result: LoginResponse = yield call(loginApi, action.payload);
    yield put(getLoginSuccess(result));
  } catch (error: any) {
    console.error('Login error:', error);
    
    let errorMessage = 'Login failed. Please try again.';
    
    if (error?.data?.message) {
      errorMessage = error.data.message;
    } else if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }
    
    yield put(getLoginFailure(errorMessage));
  }
}

function* getLogoutSaga(): Generator<any, void, any> {
  try {
    // Clear only session storage, not all localStorage
    sessionStorage.clear();
    
    // Reset the login state (this will also clear the auth state from localStorage)
    yield put(getLoginRequestReset());
    yield put(getLogoutSuccess());
  } catch (error) {
    console.error('Logout error:', error);
    yield put(getLogoutFailure('Logout failed'));
  }
}

export function* authSaga(): Generator<any, void, any> {
  yield takeEvery(getLoginRequest.type, getLoginSaga);
  yield takeEvery(getLogoutRequest.type, getLogoutSaga);
}
